<template>
  <div style="display: flex; flex-direction: column; justify-content: center; height: 100%">
    <div v-for="(pair, index) in subjectRoomPairs" :key="index">
      <div style="display: flex; justify-content: space-between; padding-top: 10px; padding-bottom: 10px">
        <div style="color: black">
          {{ pair.roomName }}
        </div>
        <div style="color: black">
          {{ pair.subjectNames }}
        </div>
      </div>
      <v-divider v-if="index < subjectRoomPairs.length - 1"></v-divider>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    item: Object,
    subjects: Array,
    rooms: Array,
    exam: String
  },
  computed: {
    subjectRoomPairs() {
      const defaultBlankItem = {
        roomName: '-',
        subjectNames: '-'
      }

      if (!this.item.data || !this.item.data.room || Object.keys(this.item.data.room).length === 0) {
        return [defaultBlankItem]
      }

      const roomData = this.item.data.room
      let pairs = []

      for (const roomId in roomData) {
        const room = this.rooms.find(r => r.id === roomId)
        const roomName = room ? room.name : '-'

        const subjectNames = roomData[roomId]
          .map(subjectId => {
            const subject = this.subjects.find(s => s.id === subjectId)
            return subject ? subject.name : '---'
          })
          .join(', ')

        pairs.push({ roomName, subjectNames })
      }

      return pairs
    }
  },
  methods: {},
  mounted() {
    this.$nextTick(() => {
      this.$forceUpdate()
    })
  }
}
</script>
